export default __webpack_public_path__ + "static/media/exclametry_bg_red.ebf90512.svg";